import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import _ from 'lodash';

import { adminCurrencyApi } from 'src/api';

import { ROUTE } from 'src/constants';
import { dumpAdminCurrencyData, dumpOptionsList, normalizeErrorResponse } from 'src/utils';

import { setAdminCurrenciesMeta, setAdminCurrencyErrors } from './adminCurrency.slice';

export const getAdminCurrencies = createAsyncThunk(
  'adminCurrency/get-admin-currencies',
  async (data, thunkApi) => {
    try {
      const copiedPayload = _.cloneDeep(data);

      for (const key in copiedPayload) {
        if (!copiedPayload[key]?.length) {
          delete copiedPayload[key];
        }
      }

      const response = await adminCurrencyApi.getAdminCurrencies(copiedPayload);

      thunkApi.dispatch(setAdminCurrenciesMeta(response?.meta));

      return response?.data;
    } catch (error) {
      console.error(error);
    }
  },
);

export const createAdminCurrency = createAsyncThunk(
  'adminCurrency/create-admin-currency',
  async (data, thunkApi) => {
    try {
      const { navigate, payload } = data;

      const copiedPayload = _.cloneDeep(payload);

      for (const key in copiedPayload) {
        if (
          typeof copiedPayload[key] !== 'object' &&
          typeof copiedPayload[key] !== 'number' &&
          typeof copiedPayload[key] !== 'boolean'
        ) {
          if (!copiedPayload[key]?.length) {
            delete copiedPayload[key];
          }
        }
      }

      copiedPayload.networks = copiedPayload.networks.map((item) => ({
        ...item,
        active: item.active ? 1 : 0,
      }));

      copiedPayload.active = copiedPayload.active ? 1 : 0;
      copiedPayload.memo = copiedPayload.memo ? 1 : 0;

      const response = await adminCurrencyApi.createAdminCurrency({
        ...copiedPayload,
        active: 1,
      });

      navigate(`${ROUTE.ADMIN.CURRENCIES.MAIN}/${response?.data}/edit`);

      toast(response.message, { type: 'success', position: 'top-right' });

      return response;
    } catch (error) {
      const { response } = error;

      thunkApi.dispatch(setAdminCurrencyErrors(normalizeErrorResponse(response.data.errors)));
    }
  },
);

export const getAdminEditCurrency = createAsyncThunk(
  'adminCurrency/get-admin-edit-currency',
  async (data) => {
    try {
      const response = await adminCurrencyApi.getAdminEditCurrency(data);

      return dumpAdminCurrencyData(response?.data);
    } catch (error) {
      console.error(error);
    }
  },
);

export const updateAdminCurrency = createAsyncThunk(
  'adminCurrency/update-admin-currency',
  async (data, thunkApi) => {
    try {
      const { id, payload } = data; // navigate

      const copiedPayload = _.cloneDeep(payload);

      for (const key in copiedPayload) {
        if (
          typeof copiedPayload[key] !== 'object' &&
          typeof copiedPayload[key] !== 'number' &&
          typeof copiedPayload[key] !== 'boolean'
        ) {
          if (!copiedPayload[key]?.length) {
            delete copiedPayload[key];
          }
        }
      }

      delete copiedPayload?.id;
      delete copiedPayload?.created_at;

      if (typeof copiedPayload?.image === 'string') {
        delete copiedPayload?.image;
      }

      copiedPayload.networks = copiedPayload.networks.map((item) => ({
        ...item,
        active: item.active ? 1 : 0,
      }));

      copiedPayload.active = copiedPayload.active ? 1 : 0;
      copiedPayload.memo = copiedPayload.memo ? 1 : 0;

      const response = await adminCurrencyApi.updateAdminCurrency(id, copiedPayload);

      // navigate(ROUTE.ADMIN.CURRENCIES.MAIN);

      toast(response.message, { type: 'success', position: 'top-right' });

      return response;
    } catch (error) {
      const { response } = error;

      thunkApi.dispatch(setAdminCurrencyErrors(normalizeErrorResponse(response.data.errors)));
    }
  },
);

export const getAdminCurrencyValidator = createAsyncThunk(
  'adminCurrency/get-admin-currency-validator',
  async (data) => {
    try {
      const response = await adminCurrencyApi.getCurrenciesValidator(data);

      return dumpOptionsList(response?.data);
    } catch (error) {
      console.error(error);
    }
  },
);

export const getAdminCurrencyLabel = createAsyncThunk(
  'adminCurrency/get-admin-currency-label',
  async (data) => {
    try {
      const response = await adminCurrencyApi.getCurrenciesLabel(data);

      return dumpOptionsList(response?.data);
    } catch (error) {
      console.error(error);
    }
  },
);

export const getAdminCurrencyPayments = createAsyncThunk(
  'adminCurrency/get-admin-currency-payments',
  async (data) => {
    try {
      const response = await adminCurrencyApi.getCurrencyPayments(data);

      return dumpOptionsList(Object.keys(response?.data));
    } catch (error) {
      console.error(error);
    }
  },
);

export const getCurrencyPaymentsType = createAsyncThunk(
  'adminCurrency/get-admin-currency-payments-type',
  async (data) => {
    try {
      const response = await adminCurrencyApi.getCurrencyPaymentsType(data);

      return response.data;
    } catch (error) {
      console.error(error);
    }
  },
);
